<template>
    <div>
        <a-popconfirm ok-text="Save"
					  cancel-text="Cancel"
                      @confirm="onSubmit"
                      @cancel="handleCancel"
        >
            <template slot="title">
                <a-card :bordered="false">
                    <a-row :gutter="[12]">
                        <a-form-model ref="editForm">
                             <a-col :span="24">
					            <a-form-model-item class="mb-10" 
                                                   label="Discount%" 
                                                   :colon="false"
                                >
						            <a-input-number 
                                        v-model="discount" 
                                        min="0" 
                                        max="100"
                                        :formatter="value => `${value}%`"
                                        :parser="value => value.replace('%', '')"
                                        onChange="handleOnChange"
                                    />
					            </a-form-model-item>
				            </a-col>

                            
                        </a-form-model>
                    </a-row>
                </a-card>
												
			</template>
            <a-button shape="circle" icon="form" size="small" />
        </a-popconfirm>
    </div>
</template>

<script>

export default {
    props : [],
    
    components : {

    },

    data () {
        return {
            discount : 0
        }
    }, 
    methods : {

        onSubmit() {
            
            this.$emit('editProductDiscountEvent', {   });
        },

        handleCancel() {

        },

        handleOnChange(value) {

        },

        
        reset() {
            
            this.discount = 0;


        }
    },
    mounted () {
       
       
    }
}
</script>

<style>

</style>